// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graphChild_VLMHK {
  height: 100%;
}

.image_gmZP8 {
  background-repeat: no-repeat;
  background-size: contain;
  height: 200px;
  width: 200px;
  background-position: 50% 50%;
}

.block_TnQAt {
  opacity: 0.1 !important;
}

.block_TnQAt:hover {
  opacity: 1;
}

.propertyGrid_QsKcu {
  --size-padMedium: 2px;
}

.custom-tooltip_yzCor {
  padding : 0px;
  margin: 0;
  background-color: transparent !important;
  border : none !important;
  box-shadow: none !important;

}

.legend_TgCQ3 {
  flex : 0 0 230px;
  padding-left : 24px;
  background-color : rgba(249, 250, 251, 1);
  border-right : 1px solid rgba(208, 213, 221, 1);
}

.iconWrapper_dFabb {
  background-color : rgba(231, 234, 239, 1);
  width : 100%;
  height : 100%;
  justify-content : center;
  align-items : center;
}

.workerCountImgContainer_ehHM0 {
  display : flex;
  justify-content : center;
  align-items : center;
  flex-grow : 1;
  width : 340px;
  height : 202px;
  overflow : hidden;
  padding : 6px 12px 6px 12px;
}

.workerCountImg_UHpyi {
  width : 100%;
  height : 100%;
  object-fit : size-down;
}

.loading_PRnpj {
  font-size: 50px;
  color : rgba(103, 121, 142, 1);
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/lineStageGanttChart/occupancyGraph/OccupancyGraph.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,aAAa;EACb,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,wCAAwC;EACxC,wBAAwB;EACxB,2BAA2B;;AAE7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,+CAA+C;AACjD;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,aAAa;EACb,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC","sourcesContent":[".graphChild {\n  height: 100%;\n}\n\n.image {\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 200px;\n  width: 200px;\n  background-position: 50% 50%;\n}\n\n.block {\n  opacity: 0.1 !important;\n}\n\n.block:hover {\n  opacity: 1;\n}\n\n.propertyGrid {\n  --size-padMedium: 2px;\n}\n\n.custom-tooltip {\n  padding : 0px;\n  margin: 0;\n  background-color: transparent !important;\n  border : none !important;\n  box-shadow: none !important;\n\n}\n\n.legend {\n  flex : 0 0 230px;\n  padding-left : 24px;\n  background-color : rgba(249, 250, 251, 1);\n  border-right : 1px solid rgba(208, 213, 221, 1);\n}\n\n.iconWrapper {\n  background-color : rgba(231, 234, 239, 1);\n  width : 100%;\n  height : 100%;\n  justify-content : center;\n  align-items : center;\n}\n\n.workerCountImgContainer {\n  display : flex;\n  justify-content : center;\n  align-items : center;\n  flex-grow : 1;\n  width : 340px;\n  height : 202px;\n  overflow : hidden;\n  padding : 6px 12px 6px 12px;\n}\n\n.workerCountImg {\n  width : 100%;\n  height : 100%;\n  object-fit : size-down;\n}\n\n.loading {\n  font-size: 50px;\n  color : rgba(103, 121, 142, 1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"graphChild": `graphChild_VLMHK`,
	"image": `image_gmZP8`,
	"block": `block_TnQAt`,
	"propertyGrid": `propertyGrid_QsKcu`,
	"custom-tooltip": `custom-tooltip_yzCor`,
	"legend": `legend_TgCQ3`,
	"iconWrapper": `iconWrapper_dFabb`,
	"workerCountImgContainer": `workerCountImgContainer_ehHM0`,
	"workerCountImg": `workerCountImg_UHpyi`,
	"loading": `loading_PRnpj`
};
export default ___CSS_LOADER_EXPORT___;
